import Main from './components/Main'

export default [
  { path: '/auth', component: Main }
]



// WEBPACK FOOTER //
// ./src/app/auth/routes.js